export const formatDate = (date, format = "DD-MM-YYYY") => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(d.getDate()).padStart(2, "0"); // Ensure two digits

    if (format === "YYYY-MM-DD") {
        return `${year}-${month}-${day}`;
    } else if (format === "MM/DD/YYYY") {
        return `${month}/${day}/${year}`;
    } else if (format === "DD-MM-YYYY") {
        return `${day}-${month}-${year}`;
    } else {
        throw new Error("Unsupported format");
    }
}

// // Example Usage
// console.log(formatDate(new Date())); // Default: "YYYY-MM-DD"
// console.log(formatDate(new Date(), "MM/DD/YYYY")); // "MM/DD/YYYY"
// console.log(formatDate(new Date(), "DD-MM-YYYY")); // "DD-MM-YYYY"
